import { CustomerApplicationSummary } from "Hooks/Api/apiCustomerApplications";
import { useCustomerApplicationDetailContext } from "../CustomerApplicationDetailPageContext";
import { CustomerApplicationAdverseAlertsWidget } from "../CustomerApplicationOverviewWidgets/CustomerApplicationAdverseAlertsWidget";
import { CustomerApplicationBusinessInfoWidget } from "../CustomerApplicationOverviewWidgets/CustomerApplicationBusinessInformationWidget";
import { CustomerApplicationQuickLinksWidget } from "../CustomerApplicationOverviewWidgets/CustomerApplicationQuickLinksWidget";
import { CustomerApplicationReferenceWidget } from "../CustomerApplicationOverviewWidgets/CustomerApplicationReferenceWidget";
import { CustomerApplicationRiskRatingsWidget } from "../CustomerApplicationOverviewWidgets/CustomerApplicationRiskRatingsWidget";

export function CustomerApplicationOverviewTab() {
	const { model = {} as CustomerApplicationSummary } = useCustomerApplicationDetailContext();

	return (
		<div className="customer-application-overview-wrapper">

			<div style={{ display: "flex", flexDirection: "row", width: '100%'  }}>
				<div style={{ display: "flex", flexDirection: "column", width: '100%' }}>
					<div style={{ display: "flex", flexDirection: "row" }}>
						<CustomerApplicationReferenceWidget model={model} />
						<CustomerApplicationRiskRatingsWidget model={model} />
					</div>
					<CustomerApplicationBusinessInfoWidget model={model} />
				</div>
			</div>

			<div style={{ display: "flex", flexDirection: "column", width: '40%' }}>
				<CustomerApplicationAdverseAlertsWidget model={model} />
				<CustomerApplicationQuickLinksWidget model={model} />
			</div>
		</div>

	)
}